var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import { connect } from 'react-redux';
import React, { Component } from 'react';

import { Translate, t } from "../../I18N";



import { getCompatibleTypes } from "../../../shared/propertyTypes";
import { SimilarProperty } from "./SimilarProperty";






class SharedProperties extends Component {
  static findProperty(id, templates) {
    return templates.reduce(
      (found, template) => {var _template$properties;return (
          found || ((_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.find((p) => p._id === id)));},
      undefined
    );
  }

  getRelationTypeName(relationTypeId) {
    const relationType = relationTypeId ?
    this.props.relationTypes.toJS().find((r) => r._id === relationTypeId) :
    undefined;
    return relationType ? relationType.name : undefined;
  }

  getThesauriName(thesauriId) {
    const thesaurus = thesauriId ?
    this.props.thesauris.toJS().find((thesauri) => thesauri._id === thesauriId) :
    undefined;
    return thesaurus ? thesaurus.name : undefined;
  }

  findSameLabelProperties(label, templates) {
    return templates.
    filter((template) => template._id !== this.props.templateId && template.properties).
    map((template) => {
      const property = (template.properties || []).find(
        (prop) => prop.label.trim().toLowerCase() === label.trim().toLowerCase()
      );
      return (
        property ? { template: template.name, property } : { template: undefined });

    }).
    filter((prop) => prop.template !== undefined);
  }

  render() {
    const { type, content, relationType, inherit, label, templates } = this.props;
    const _templates = templates.toJS();
    const inheritedProperty = SharedProperties.findProperty(inherit === null || inherit === void 0 ? void 0 : inherit.property, _templates);
    const similarProperties = this.findSameLabelProperties(
      label,
      _templates
    ).map((propertyMatch) => {var _property$inherit;
      const { property } = propertyMatch;

      const otherInheritedProperty = SharedProperties.findProperty((_property$inherit =
      property.inherit) === null || _property$inherit === void 0 ? void 0 : _property$inherit.property,
      _templates
      );

      return _objectSpread(_objectSpread({},
      propertyMatch), {}, {
        typeConflict: !getCompatibleTypes(type).includes(property.type),
        relationConflict: relationType && property.relationType !== relationType,
        contentConflict: property.content !== content,
        type: property.type,
        relationTypeName: this.getRelationTypeName(property.relationType),
        thesaurusName: this.getThesauriName(property.content),
        inheritConflict: (inheritedProperty === null || inheritedProperty === void 0 ? void 0 : inheritedProperty.type) !== (otherInheritedProperty === null || otherInheritedProperty === void 0 ? void 0 : otherInheritedProperty.type),
        inheritType: otherInheritedProperty === null || otherInheritedProperty === void 0 ? void 0 : otherInheritedProperty.type });

    });

    const thisTemplateLabel = t('System', 'this template', null, false);
    const thisProperty = {
      template: `${this.props.templateName} (${thisTemplateLabel})`,
      type,
      relationTypeName: this.getRelationTypeName(relationType),
      thesaurusName: this.getThesauriName(content),
      typeConflict: false,
      contentConflict: false,
      relationConflict: false,
      inheritConflict: false,
      inheritType: inheritedProperty === null || inheritedProperty === void 0 ? void 0 : inheritedProperty.type
    };

    const templatesWithSameLabelProperties = [thisProperty, ...similarProperties];
    const hasContent = templatesWithSameLabelProperties.find((prop) => prop.thesaurusName);
    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("label", { className: "suggestions-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Properties from other templates in the collection using the same label"

      )
      ), /*#__PURE__*/
      _jsx("table", { className: "table" }, void 0, /*#__PURE__*/
      _jsx("thead", {}, void 0, /*#__PURE__*/
      _jsx("tr", {}, void 0, /*#__PURE__*/
      _jsx("th", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Template")
      ), /*#__PURE__*/
      _jsx("th", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Type")
      ),
      hasContent && /*#__PURE__*/
      _jsx("th", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Thesauri"), "/", /*#__PURE__*/_jsx(Translate, {}, void 0, "Entity")
      )

      )
      ), /*#__PURE__*/
      _jsx("tbody", {}, void 0,
      templatesWithSameLabelProperties.map((templateProperty, index) => /*#__PURE__*/
      _jsx(SimilarProperty, { templateProperty: templateProperty }, index)
      )
      )
      )
      ));

  }
}
















export function mapStateToProps(state, props) {
  const propertySchemaElement = state.template.data.properties[props.index];
  const { relationTypes } = state;
  return {
    templates: state.templates,
    thesauris: state.thesauris,
    relationTypes,
    templateName: state.template.data.name,
    templateId: state.template.data._id,
    type: propertySchemaElement.type,
    filter: propertySchemaElement.filter,
    label: propertySchemaElement.label,
    content: propertySchemaElement.content,
    relationType: propertySchemaElement.relationType,
    inherit: propertySchemaElement.inherit
  };
}

export const FilterSuggestions = connect(mapStateToProps)(SharedProperties);